import React from 'react';
import { useNavigate } from 'react-router-dom';
import useChargebacks from './hooks/useChargebacks';
import ChargebacksView from './view';

export default function ChargebacksSection() {
    const navigate = useNavigate();
    const state = useChargebacks();

    return <ChargebacksView {...state} navigate={navigate} />;
}
